import BasePriceBinder from './BasePriceBinder';

export default class RadioBinder extends BasePriceBinder {
	optionValue;
	optionLabel;

	constructor(
		id,
		title,
		calculator,
		summaryDisplayer,
		priceFormatter,
		optionLabel,
		optionValue
	) {
		super(
			id,
			`${title} (${optionLabel})`,
			calculator,
			summaryDisplayer,
			priceFormatter
		);
		this.optionLabel = optionLabel;
		this.optionValue = optionValue;
		this.optionId = `${this.id}_${optionValue}`;
		this.baseElement = document.getElementsByName(this.id);
		this.isActive = this.baseElement.value === this.optionValue;
	}

	initEvents() {
		this.baseElement.forEach((element) => {
			element.addEventListener('change', (e) => {
				this.isActive = e.target.value === this.optionValue;
				this.handleChange();
			});
		});

		super.initEvents();
	}
}
